import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import SideMenu from "../../Elements/SideMenu";
import Table from "../../Elements/Table";
// import UpcomingVisits from "../../Elements/UpcomingVisits";
import RightSectionCommon from "../../Elements/RightSectionCommon";
// import ChatSection from "../../Elements/ChatSection";
// import searchIcon from "../../../Assets/Icons/search-icon.svg";
// import filterIcon from "../../../Assets/Icons/filter-icon.svg";
// import shareIcon from "../../../Assets/Icons/share-icon.svg";
import rightArrow from "../../../Assets/Icons/right-arrow.svg";
// import increaseStats from "../../../Assets/Icons/increase-stats.svg";
// import decreaseStats from "../../../Assets/Icons/decrease-stats.svg";
import "./styles.css";
import { paths } from "../../../Constants/paths";
import { getPatients } from "../../../Services";
import { getDDMMYY, getAge, getGenderCode } from "../../../Helpers/index";
import PatientsFilter from "../../Elements/Modal/PatientsFilter";
import ShareModal from "../../Elements/Modal/ShareModal";

// const stats = [
//   {
//     id: 1,
//     value: "59",
//     change: "increase",
//     percentage: "4.2%",
//     label: "Visits for Today",
//   },
//   {
//     id: 1,
//     value: "27",
//     change: "decrease",
//     percentage: "2.8%",
//     label: "New Patients",
//   },
//   {
//     id: 1,
//     value: "32",
//     change: "increase",
//     percentage: "3.5%",
//     label: "Old Patients",
//   },
// ];

const Dashboard = () => {
  const navigate = useNavigate();
  const { physician } = useAuth();
  const [patients, setPatients] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [shareToggle, setShareToggle] = useState(false);
  const [currSort, setCurrSort] = useState({ field: "", dir: 1 });

  useEffect(() => {
    const fetchPatients = async () => {
      try {
        const physicianId = physician.physician._id;
        const patientsData = await getPatients(physicianId);
        setPatients(patientsData.data.entries);
      } catch (error) {
        console.error("Error fetching patients:", error);
      }
    };

    fetchPatients();
  }, []);

  let columns = [
    {
      id: 1,
      label: "Patient",
      subText: "(Name,ID)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("firstName"),
      minWidth: "180px",
      width: "21%",
    },
    {
      id: 2,
      label: "Date",
      subText: "(of Diagnosis)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("dateofDiagnosis"),
      minWidth: "100px",
      width: "11%",
    },
    {
      id: 3,
      label: "Cancer",
      subText: "(Stage, Molecular Mutation)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("cancerType"),
      minWidth: "200px",
      width: "24%",
    },
    {
      id: 4,
      label: "Recent Activity",
      subText: "(Type , Date)",
      isIcon: false,
      iconsList: [],
      sortingRequired: false,
      minWidth: "150px",
      width: "17%",
    },
    {
      id: 5,
      label: "Category",
      subText: "(Patient Category)",
      isIcon: false,
      iconsList: [],
      sortingRequired: true,
      sortingFunction: () => handleSort("type"),
      minWidth: "100px",
      width: "17%",
    },
    // Disabled for phase 1
    {
      id: 6,
      label: "",
      subText: "",
      isIcon: true,
      // iconsList: [{ icon: filterIcon }, { icon: searchIcon }],
      sortingRequired: false,
      minWidth: "100px",
      width: "11%",
    },
  ];

  // Transform fetched patient data into the format expected by the table
  const rows = patients.map((patient) => {
    return {
      _id: patient._id,
      disabled: false,
      tableData: [
        {
          id: 1,
          text: `${patient.firstName} ${patient.lastName}`,
          subText: `#${patient.patientId}`,
          subYellowButton: "",
          subGreyButton: `${getAge(patient.dateOfBirth)}, ${getGenderCode(
            patient.gender
          )}`,
          star: {
            isSubStar: true,
            isStarred: `${getAge(patient.isStarred)}`,
          },
        },
        {
          id: 2,
          text: `${
            patient.diagnosis.dateofDiagnosis
              ? getDDMMYY(patient.diagnosis.dateofDiagnosis)
              : ""
          }`,
        },
        {
          id: 3,
          text: `${patient.diagnosis.cancerType || ""}`,
          subText: "Stage",
          subYellowButton: `${
            patient.staging && patient.staging.length > 0
              ? patient.staging[patient.staging.length - 1]?.stage || "N/A"
              : ""
          }`,
          subGreyButton: `${
            patient.genomicFindings.name ? patient.genomicFindings?.name : ""
          }`,
          star: {
            isSubStar: false,
            isStarred: false,
          },
          disableButton: "",
          isButton: false,
          buttonList: [],
          containsProfileImage: false,
        },
        {
          id: 4,
          text: "",
          subText: "",
          subYellowButton: "",
          subGreyButton: "",
          star: {
            isSubStar: false,
            isStarred: false,
          },
          disableButton: "",
          isButton: false,
          buttonList: [],
          containsProfileImage: false,
        },
        {
          id: 5,
          text: "",
          subText: "",
          subYellowButton: "",
          subGreyButton: "",
          star: {
            isSubStar: false,
            isStarred: false,
          },
          isButton: false,
          disableButton: `${patient.type}`,
          buttonList: [],
          containsProfileImage: false,
        },
        {
          id: 6,
          text: "",
          subText: "",
          subYellowButton: "",
          subGreyButton: "",
          star: {
            isSubStar: false,
            isStarred: false,
          },
          isButton: true,
          disableButton: "",
          buttonList: [
            // Disabled for phase 1
            // {
            //   btntext: "Share",
            //   btnIcon: shareIcon,
            // },
            {
              btntext: "Details",
              btnIcon: rightArrow,
            },
          ],
          containsProfileImage: false,
        },
      ],
    };
  });

  const currentDate = new Date();
  const dayOfWeek = currentDate.getDay();

  // Convert the numeric day to a string
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const dayName = daysOfWeek[dayOfWeek]; // This will give the name of the day (e.g., "Sunday", "Monday").
  // Get the month and day components
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[currentDate.getMonth()];
  const day = currentDate.getDate();

  // Format the date as "Month Day"
  const formattedDate = `${day} ${month}`; // This will give "Oct 16" for October 16th.

  const onButtonClick = (row, buttonIndex) => {
    const patientId = row._id;
    // console.log(patientId);
    navigate(`${paths.patient.details}/${patientId}`);
  };

  const onIconClick = (row, buttonIndex) => {
    setIsFilterModalOpen(true);
  };

  const onShareClick = (row, buttonIndex) => {
    setShareToggle(true);
  };

  /**
   * Function to sort items in acsending or decsending order
   * @param {*} sortedField - name of field or column to be sorted
   * @param {*} dir - direction
   */
  const handleSort = (sortedField) => {
    if (patients.length > 0) {
      let sortedProducts = [...patients];
      let dir = currSort.dir;
      if (sortedField !== null) {
        if (currSort.field === sortedField) {
          currSort.dir *= -1;
          dir *= -1;
        } else {
          setCurrSort({ field: sortedField, dir: 1 });
          dir = 1;
        }
        sortedProducts.sort((a, b) => {
          if (a[sortedField] < b[sortedField]) {
            return dir === 1 ? -1 : 1;
          }
          if (a[sortedField] > b[sortedField]) {
            return dir === 1 ? 1 : -1;
          }
          return 0;
        });
      }
      setPatients(sortedProducts);
    }
  };

  return (
    <div className="container">
      <SideMenu />
      <div className="left-section">
        <div className="welcome-text-container">
          <h2 className="h2-400 dark-grey">
            Welcome back, Dr. {physician.firstName} {physician.lastName}
          </h2>
          <h5 className="h5-400 dark-grey">
            Today is {dayName}, {formattedDate}
          </h5>
        </div>
        <div className="heading-stats-container">
          <h1 className="h1-400 blue">Patients</h1>
          {/* <div className="stats-all-container">
            {stats.map((item, index) => (
              <div className="stats-container" key={index}>
                <h3 className="h3-400 blue small-title">{item.value}</h3>
                <div>
                  <p className="associated-text medium-grey">{item.label}</p>
                  <p className="body2 medium-grey">
                    <span
                      className={
                        item.change === "decrease"
                          ? "stats-text red"
                          : "stats-text green"
                      }
                    >
                      <img
                        className="stats-icon"
                        src={
                          item.change === "decrease"
                            ? decreaseStats
                            : increaseStats
                        }
                        alt="stats-icon"
                      />
                      {item.percentage}
                    </span>{" "}
                    from last week
                  </p>
                </div>
              </div>
            ))}
          </div> */}
        </div>
        <div className="dashboard-table-frame">
          <Table
            columnList={columns}
            rowList={rows}
            screen="dashboard"
            onButtonClick={onButtonClick}
            onIconClick={onIconClick}
            onShareClick={onShareClick}
            view="expanded"
          />
        </div>
      </div>
      <div id="right-section">
        <RightSectionCommon />
        {/* <div className="right-section-bottom">
          <ChatSection />
        </div> */}
      </div>
      {/* Show Filter Modal when Filter button in the table is clicked*/}
      {isFilterModalOpen && (
        <PatientsFilter onClose={() => setIsFilterModalOpen(false)} />
      )}
      {shareToggle && <ShareModal onClose={() => setShareToggle(false)} />}
    </div>
  );
};

export default Dashboard;
